function sendMessageToWebViewEvent(message: string) {
  window.ReactNativeWebView?.postMessage(message);
}

export default sendMessageToWebViewEvent;
